import { createSlice } from '@reduxjs/toolkit'
import initialState from "./initialState";
import reducers from "./reducers";
import { liquidAddressDetails, liquidClient, liquidSaveAddress } from "./thunks";

export const elementsSlice = createSlice({
  name: 'elements',
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(liquidClient.fulfilled, (state, action) => {
        const assets = action?.payload;
        if (assets) {
          state.liquid = assets;
        } else {
          // SDK returned but with no assets - this is an error condition
          state.secure = false;
        }
        state.loading = false
      })
      .addCase(liquidClient.pending, (state, action) => {
        state.loading = true
      })
      .addCase(liquidClient.rejected, (state, action) => {
        state.loading = false
        state.secure = false
      })
      .addCase(liquidAddressDetails.fulfilled, (state, action) => {
        state.newAddress = action?.payload
        state.addressUpdated = true
      })
      .addCase(liquidSaveAddress.fulfilled, (state, action) => {
        state.address = action?.payload
        state.addressUpdated = true
      })
  }
})

export const {
  setSecure,
  setLoading,
  setAddress,
  setAddressActive,
  setCartId,
} = elementsSlice.actions

const reducer = elementsSlice.reducer
export default reducer
